import { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import {
  createRoutesFromChildren,
  matchRoutes,
  BrowserRouter,
  useLocation,
  useNavigationType,
} from 'react-router-dom'

import '@/scss/style.scss'

import App from './App'
import RouteChangeTracker from './RouteChangeTracker'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  ignoreErrors: [
    // 정규표현식으로 청크 로드 에러 무시
    /Failed to fetch dynamically imported module/,
    /Loading chunk .* failed/,
    /Importing a module script failed/,
  ],
})

ReactDOM.createRoot(document.getElementById('root') as HTMLElement, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <BrowserRouter>
    <RouteChangeTracker />
    <App />
  </BrowserRouter>,
)
